import { render, staticRenderFns } from "./VoiceAnimation.vue?vue&type=template&id=2563a089&scoped=true"
var script = {}
import style0 from "./VoiceAnimation.vue?vue&type=style&index=0&id=2563a089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563a089",
  null
  
)

export default component.exports